/**
 * landing.ts — Trang giới thiệu eCDP (tên miền chính ecdp.vn).
 *
 * Bản mặc định là file tĩnh `public/landing/index.html` (đi kèm mã nguồn). Quản trị Platform có thể thay bằng bản HTML tải lên và đặt
 * video cho nút "Khám phá eCDP" (Platform → Trang giới thiệu; backend `platform/landing-page-routes.ts`).
 * Hiển thị: `/gioi-thieu` trên mọi tên miền của app, và "/" khi truy cập bằng tên miền giới thiệu (`VITE_LANDING_HOSTS`, mặc định ecdp.vn).
 */
import { API_BASE } from './config'

export const DEFAULT_LANDING_HOSTS = ['ecdp.vn', 'www.ecdp.vn']
/** Tên miền app thật — nút "Đăng nhập", "Dùng thử" trên tên miền giới thiệu trỏ về đây. */
export const PRODUCTION_APP_URL = 'https://app.ecdp.vn'

export function landingHosts(env: string | undefined = import.meta.env.VITE_LANDING_HOSTS): string[] {
  const list = (env ?? '').split(',').map((h) => h.trim().toLowerCase()).filter(Boolean)
  return list.length ? list : DEFAULT_LANDING_HOSTS
}

export function isLandingHost(hostname: string, hosts: string[] = landingHosts()): boolean {
  return hosts.includes(hostname.toLowerCase())
}

/** Địa chỉ app cho nút đăng nhập: ở tên miền giới thiệu → app.ecdp.vn; ở chính app (dev, app) → cùng origin. */
export function appUrlFor(hostname: string, origin: string, hosts: string[] = landingHosts()): string {
  return isLandingHost(hostname, hosts) ? PRODUCTION_APP_URL : origin
}

export interface LandingState { custom: boolean; videoUrl: string; updatedAt?: string | null }

/**
 * Nguồn khung hiển thị: bản tải lên (API, chạy trong sandbox) hoặc bản mặc định kèm tham số app + api + video
 * (`api` để mục Bảng giá đọc `GET {api}/public/pricing`).
 */
export function landingFrameSrc(state: LandingState | null, appUrl: string, apiBase: string = API_BASE): string {
  if (state?.custom) return `${apiBase}/public/landing/html${state.updatedAt ? `?v=${encodeURIComponent(state.updatedAt)}` : ''}`
  const q = new URLSearchParams({ app: appUrl, api: apiBase })
  if (state?.videoUrl) q.set('video', state.videoUrl)
  return `/landing/index.html?${q.toString()}`
}
